import { render, staticRenderFns } from "./RemoveArrestPrepareArgsForm.vue?vue&type=template&id=79b0013e&scoped=true&"
import script from "./RemoveArrestPrepareArgsForm.vue?vue&type=script&lang=ts&"
export * from "./RemoveArrestPrepareArgsForm.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveArrestPrepareArgsForm.vue?vue&type=style&index=0&id=79b0013e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0013e",
  null
  
)

export default component.exports